import { Component, Suspense } from "react";
import { COLUMN_CODE, TableManger, TABLES } from "../../../managers/TableManger";
import DataGridHolderPayroll from "../../common/DataGridHolderPayroll";
import {
    DKLabel,
    DKSpinner,
    DKButton,
    DKCalendar,
    INPUT_VIEW_DIRECTION,
    DKInput,
    DKIcons
} from "deskera-ui-library";
import RouteManager from "../../../managers/RouteManager";
import { PipelineManager } from "../../../managers/PipelineManager";
import { AUTOMATION_ACTIONS, AUTOMATION_TRIGGERS, DATE_ALERT_CRITERIA, FILTER_OPERATORS_NAMES, SPLIT_ACTION_TYPE, TRIGGER_ON_CONDITION, WORKFLOW_NODE_MAPPING } from "../AutomationConstants";
import FormatCurrencyService from "../../../services/FormatCurrencyService";
import AutomationService from "../../../services/automation";
import { DATE_FORMAT, FORMAT, INPUT_TYPE } from "../../../constants/Constant";
import Utility, { deepClone, removeDelayedLoader, showDelayedLoader } from "../../../utility/Utility";
import Table from "../../../services/table";
import { WORKFLOW_REPORT_COLUMNS } from "./AutomationReportsCommon";
import moment from 'moment';
import calender from '../../../assets/icons/white/date_range.svg';
import { JobPipelineManager } from "../../../managers/JobPipelineManager";
import { decodeBase64Uri, encodeBase64Uri } from "../../../managers/common/CommonUtil";
import { fetchUsersExpenseGroup, fetchUsersListWithTeams } from "../../../Redux/Slices/PayrollSlice";
import { fetchCustomFields } from "../../../Redux/Slices/CustomFieldsSlice"
import { connect } from "react-redux";
import CustomFieldService from "../../../services/CustomFieldService";
import AutomationManager from "../AutomationManager";

const KEY_CONST = {
    PIPELINE: "${Pipeline.",
    SYS_VAR: "${sys_var.",
    CANDIDATE: "${Candidate.",
    INVOICE_CREATED: "${Invoice Created.",
    EXPENSE_CREATED: "${Expense Created.",
    DATE_ALERT_TRIGGER: "${Date alert trigger.",
    TIME_OFF_CREATED: "${Time Off Created."
};

let searchTimeout;

class WorkflowReport extends Component {
    pipelines = [];
    jobPipelines = [];

    constructor(props) {
        super(props)
        this.state = {
            currentPage: 1,
            totalPageCount: 1,
            reportData: {
                columnData: [],
                rowData: [],
                originalData: [],
                filter: []
            },
            maxSteps: 0,
            automations: [],
            selectedAutomation: null,
            filters: [],
            datePeriod: {
                toggle: false,
                startDate: moment(moment().format()).startOf('month'),
                endDate: moment(moment().format()).endOf('month'),
                defaultDate: false
            }
        }
    }

    async componentDidMount() {
        RouteManager.setPresenter(this);

        PipelineManager.get().then(() => {
            this.pipelines = PipelineManager.processPipelineData();
        });
        JobPipelineManager.get().then(() => {
            this.jobPipelines = JobPipelineManager.processJobPipelineData();
        });

        if (Utility.isEmpty(this.props.users)) {
            await this.props.fetchUsersExpenseGroup();
        }
        if (Utility.isEmpty(this.props.usersWithTeam)) {
            await this.props.fetchUsersListWithTeams();
        }
        if(Utility.isEmpty(this.props.customFields)) {
            CustomFieldService.apiConfig = {
                Module: "employee_details",
            };
            await this.props.fetchCustomFields();
        }

        this.registerGlobalFunctions(true);
        this.getAutomations();
    }

    componentWillUnmount() {
        this.registerGlobalFunctions(false);
    }

    getAutomations() {
        const params = {
            pageNo: 1,
            pageSize: 1000
        };

        Table.getRecordsByPage(params, null, TableManger.getTableId(TABLES.PEOPLE_AUTOMATION)).then(
            (response) => {
                if (response?.data?.length > 0) {
                    const workflowIdColumnId = TableManger.getColumnId(TABLES.PEOPLE_AUTOMATION, COLUMN_CODE.PEOPLE_AUTOMATION.WORKFLOW_ID);
                    const workflowNameColumnId = TableManger.getColumnId(TABLES.PEOPLE_AUTOMATION, COLUMN_CODE.PEOPLE_AUTOMATION.NAME);
                    const automations = [];
                    response.data.forEach((record) => {
                        automations.push({
                            id: record._id,
                            wId: record.cells[workflowIdColumnId],
                            name: record.cells[workflowNameColumnId]
                        });
                    });

                    this.setState({
                        automations: automations
                    }, () => {
                        if (!isNaN(parseInt(this.props.match.params.id))) {
                            this.setAutomation(parseInt(this.props.match.params.id));
                        } else {
                            this.setAutomation(automations[0]?.wId);
                        }
                    });
                } else {
                    this.setReportData([]);
                }
            }
        ).catch((error) => { });
    }

    setAutomation(automationId) {
        if (automationId) {
            this.setState({
                selectedAutomation: automationId
            }, () => {
                this.getAutomationReport();
            });
        }
    }

    getAutomationReport(searchStr) {
        const timer = showDelayedLoader();
        const automationId = this.state.selectedAutomation;
        if (automationId) {
            const params = this.getParams(searchStr);
            AutomationService.getAutomationReport(automationId, params).then(response => {
                removeDelayedLoader(timer);
                if (response?.data?.wf_executed) {
                    let maxSteps = 0;
                    response.data.wf_executed.forEach((wf) => {
                        if (wf.workflow_graph) {
                            const workflowGraph = JSON.parse(wf.workflow_graph);
                            if (workflowGraph?.graphNodes?.length > maxSteps) {
                                maxSteps = workflowGraph.graphNodes.length;
                            }
                        }
                    });
    
                    this.setState({
                        maxSteps: maxSteps
                    }, () => {
                        const rowData = this.getRowData(response.data);
                        this.setReportData(rowData, response["page"], response["total_pages"]);
                    });
                } else {
                    this.setState({
                        maxSteps: 0
                    }, () => {
                        this.setReportData([]);
                    });
                }
            }, error => {
                removeDelayedLoader(timer);
            });
        }
    }

    getParams(searchStr) {
        const params = {
            limit: 20,
            currentPage: this.state.currentPage,
        }

        if (this.state.datePeriod.startDate && this.state.datePeriod.endDate) {
            params["startDate"] = moment(this.state.datePeriod.startDate).format(FORMAT.YYYYMMDD);
            params["endDate"] = moment(this.state.datePeriod.endDate).format(FORMAT.YYYYMMDD);
        }

        if (searchStr) {
            params["searchStr"] = searchStr;
        }

        return params;
    }

    parseKey(key) {
        let VAR = null;

        if (key) {
            if (key.startsWith(KEY_CONST.PIPELINE)) {
                VAR = KEY_CONST.PIPELINE;
            } else if (key.startsWith(KEY_CONST.SYS_VAR)) {
                VAR = KEY_CONST.SYS_VAR;
            } else if (key.startsWith(KEY_CONST.CANDIDATE)) {
                VAR = KEY_CONST.CANDIDATE;
            } else if (key.startsWith(KEY_CONST.INVOICE_CREATED)) {
                VAR = KEY_CONST.INVOICE_CREATED;
            } else if (key.startsWith(KEY_CONST.EXPENSE_CREATED)) {
                VAR = KEY_CONST.EXPENSE_CREATED;
            } else if (key.startsWith(KEY_CONST.DATE_ALERT_TRIGGER)) {
                VAR = KEY_CONST.DATE_ALERT_TRIGGER
            } else if (key.startsWith(KEY_CONST.TIME_OFF_CREATED)) {
                VAR = KEY_CONST.TIME_OFF_CREATED
            }

            if (VAR) {
                return key.substring(key.indexOf(VAR) + VAR.length, key.length - 1);
            }
        }
    }

    parseVariables(variablesString) {
        let variables = null;

        if (variablesString) {
            try {
                variables = {};
                Object.entries(JSON.parse(variablesString)).forEach(([key, value]) => {
                    const parsedKey = this.parseKey(key);
                    if (parsedKey) {
                        variables[parsedKey] = value;
                    }
                });
            } catch { }
        }

        return variables;
    }

    parseWFGraph(wfGraphString) {
        let wfGraph = null;

        try {
            wfGraph = JSON.parse(wfGraphString);
        } catch { }

        return wfGraph;
    }

    getStep(steps, nodeExecId) {
        if (steps?.length > 0) {
            return steps.find((s) => s.id === nodeExecId);
        }
    }

    getRowData(reportData) {
        const rowData = [];
        const wfExecutionData = reportData?.wf_executed?.length > 0 ? reportData.wf_executed : [];

        wfExecutionData.forEach((wf) => {
            const row = {
                executionStart: Utility.formatDate(wf.processing_start_at, DATE_FORMAT.YYYYMMDD),
                executionEnd: Utility.formatDate(wf.processing_end_at, DATE_FORMAT.YYYYMMDD),
                executionTime: wf.exec_time ? String(wf.exec_time).concat("ms") : "",
            };

            let previousStepResult = 1;
            const wfGraph = this.parseWFGraph(wf.workflow_graph);
            wfGraph.graphNodes.sort((n1, n2) => n1.id - n2.id);
            
            for (let index = 0; index < wfGraph.graphNodes.length; index++) {
                const step = wfGraph.graphNodes[index];
                const node = wf.node_executed.find((n) => n.node_executed_id === step.id);

                if (node) {
                    node["variables"] = this.parseVariables(node.variables);
                }

                const config = {
                    nodeType: step.node_type,
                    name: step.name,
                    original: {},
                    source: {},
                    result: !node ? -1 : 0
                };

                row[this.generateColumnId(index + 1)] = this.getDisplayData(config, step, node);

                previousStepResult = config.result;
            }

            if (previousStepResult !== 0) {
                row[`STEP${wfGraph.graphNodes.length + 1}`] = this.getEndAutomationText();
            }

            rowData.push(row);
        });

        return rowData
    }

    getDisplayData(config, step, node) {
        if (step) {
            this.populateStepConfig(config, step, node);
        }

        this.populateStepExepectedResult(config, node?.variables);

        return this.buildStepData(config);
    }

    populateStepExepectedResult(config, variables) {
        switch (config.nodeType) {
            case WORKFLOW_NODE_MAPPING[AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON]:
                if (config.original["Pipeline"] === config.source["Pipeline"] && config.original["Stage"] === config.source["Stage"]) {
                    config["result"] = 1;
                }
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_TRIGGERS.PEOPLE_INVOICE_CREATED]:
                if (config.source["Invoice Code"] && (config.source["Created By"] || config.source["Sales Person"])) {
                    config["result"] = 1;
                }
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_TRIGGERS.EXPENSE_CREATED]:
                if (config.source["Expense ID"]) {
                    config["result"] = 1;
                }
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.SPLIT_WORKFLOW]:
            case WORKFLOW_NODE_MAPPING[SPLIT_ACTION_TYPE.DESIGNATION]:
                if (config.original["Designation"]?.split(", ")?.length > 0) {
                    config.original["Designation"].split(", ").forEach((designation) => {
                        if (designation === config.source["Designation"]) {
                            config["result"] = 1;
                        }
                    });
                }
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.CALCULATE_COMMISSION]:
            case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.INVOICE_COMMISSION]:
                if (config.source["Commission Amount"] !== "-") {
                    config["result"] = 1;
                }
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_TRIGGERS.PEOPLE_CANDIDATE_STAGE_CHANGED]:
                if (config.original["Job Pipeline"] === config.source["Job Pipeline"]) {
                    config["result"] = 1;
                }
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.SEND_EMAIL]:
                if (config.source["Email Template"] !== "-") {
                    config["result"] = 1;
                }
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.EXPENSE_APPROVAL]:
                const isApplicantMatched = config.original["Approval For"]?.includes(config.source["Applicant Name"]);

                if (isApplicantMatched) {
                    if (config.original["Total Amount"]) {
                        const expenseAmount = config.source["Expense Amount"] ? parseFloat(config.source["Expense Amount"]) : 0;
                        const operator = config.original["Total Amount"].substring(0, 2).trim();
                        const totalAmount = config.original["Total Amount"] ? parseFloat(config.original["Total Amount"].substring(2).trim()) : 0;
    
                        if (eval(`${expenseAmount} ${operator} ${totalAmount}`)) {
                            config["result"] = 1;
                        }
                    } else {
                        config["result"] = 1;
                    }
                }
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_TRIGGERS.PEOPLE_DATE_ALERT]:
                if(variables?.isDateAlertExecuted || !Utility.isEmpty(variables?.emailSentUser)) {
                    config["result"] = 1;
                }
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED]:
                if (config.source["Applicant Name"] && config.source["From Date"] && config.source["To Date"]) {
                    config["result"] = 1;
                }
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.LEAVE_APPROVAL]:
                const isLeaveMatched = config.original["Approval For"]?.includes(config.source["Applicant Name"]);

                if (isLeaveMatched) {
                    let leaveDurationMatched = false;
                    if (config.original["Time Off Duration"]) {
                        const automationDuration = config.source["Time Off Duration"] ? parseFloat(config.source["Time Off Duration"]) : 0;
                        const operator = config.original["Time Off Duration"].substring(0, 2).trim();
                        const leaveDuration = config.original["Time Off Duration"] ? parseFloat(config.original["Time Off Duration"].substring(2).trim()) : 0;

                        if (eval(`${automationDuration} ${operator} ${leaveDuration}`)) {
                            leaveDurationMatched = true;
                        }
                    }

                    let leaveTypeMatched = false;
                    if (config.original["Time Off Policy"]) {
                        if (config.original["Time Off Policy"] === "Any" || config.original["Time Off Policy"] === config.source["Time Off Policy"]) {
                            leaveTypeMatched = true;
                        }
                    }

                    if (leaveDurationMatched && leaveTypeMatched) {
                        config["result"] = 1;
                    }
                }
                break;
        }
    }

    buildStepData(config) {
        return (
            `<div class="column">
                <div class="row mb-s">
                    <span class="fw-m">Step Name: </span>
                    <span>${config.name}</span>
                </div>
                <div class="column mb-s">
                    <div class="row">
                        <span class="fw-m">Automation Data:</span>
                    </div>
                    <ul class="column m-0">
                        ${
                            Object.entries(config.original).map(([key, value]) => {
                                return `<li>${key}: ${value}</li>`;
                            }).join("")
                        }
                    </ul>
                </div>
                <div class="column mb-s">
                    <div class="row">
                        <span class="fw-m">Source Data:</span>
                    </div>
                    <ul class="column m-0">
                        ${
                            Object.entries(config.source).map(([key, value]) => {
                                return `<li>${key}: ${value}</li>`;
                            }).join("")
                        }
                    </ul>
                </div>
                <div class="row">
                    <span class="fw-m">Execution Result: </span>
                    <span>${this.getExecutionResultText(config.result)}</span>
                </div>
            </div>`
        );
    }

    getExecutionResultText(result) {
        switch (result) {
            case 1:
                return "<span class='fw-m text-app'>Success</span>";
            case 0:
                return "<span class='fw-m text-red'>Failure</span>";
            case -1:
                return "<span class='fw-m'>Not Executed</span>";
        }
    }

    getEndAutomationText() {
        return `<span class="fw-m">End Automation</span>`;
    }

    populateStepConfig(config, step, node) {
        const { node_type, fields } = step;

        switch (node_type) {
            case WORKFLOW_NODE_MAPPING[AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON]:
                const pipelineColumn = TableManger.getColumnById(TABLES.DEAL, TableManger.getColumnId(TABLES.DEAL, COLUMN_CODE.DEAL.PIPELINE_ID));
                const stageColumn = TableManger.getColumnById(TABLES.DEAL, TableManger.getColumnId(TABLES.DEAL, COLUMN_CODE.DEAL.STAGE_ID));
                this.populatePipelineAndStageData(config, fields, node?.variables, pipelineColumn, stageColumn);
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_TRIGGERS.PEOPLE_INVOICE_CREATED]:
                this.populateInvoiceCreateData(config, fields, node?.variables);
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_TRIGGERS.EXPENSE_CREATED]:
                this.populateExpenseCreateData(config, fields, node?.variables);
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.SPLIT_WORKFLOW]:
                this.populateSplitWorkFlowData(config, fields, node?.variables);
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.DESIGNATION]:
                this.populateDesignationData(config, fields, node?.variables);
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.CALCULATE_COMMISSION]:
                this.populateCommissionData(config, fields, node?.variables);
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_TRIGGERS.PEOPLE_CANDIDATE_STAGE_CHANGED]:
                this.populateStageChangeData(config, fields, node?.variables);
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.SEND_EMAIL]:
                this.populateSendMailData(config, fields, node?.variables);
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.INVOICE_COMMISSION]:
                this.populateInvoiceCommissionData(config, fields, node?.variables);
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.EXPENSE_APPROVAL]:
                this.populateExpenseApprovalData(config, fields, node?.variables);
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_TRIGGERS.PEOPLE_DATE_ALERT]:
                this.populateDateAlertData(config, fields, node?.variables);
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED]:
                this.populateLeaveCreateData(config, fields, node?.variables);
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.LEAVE_APPROVAL]:
                this.populateLeaveApprovalData(config, fields, node?.variables);
                break;
        }
    }

    populatePipelineAndStageData(config, fields, variables, pipelineColumn, stageColumn) {
        let originalStages;
        let sourceStages;

        config.source["Deal Name"] = variables?.name || "-";
        config.source["Deal Owner"] = this.getUserName(variables?.user?.firstName, variables?.user?.lastName) || "-";

        if (pipelineColumn) {
            const field = fields.find((f) => f.code === pipelineColumn.key);
            this.pipelines.forEach((o) => {
                if (o.id === field.value) {
                    originalStages = o.stages;
                    config.original["Pipeline"] = o.name;
                }

                if (o.id === variables?.pipelineId) {
                    sourceStages = o.stages;
                    config.source["Pipeline"] = o.name;
                }
            });
        }

        if (stageColumn) {
            const field = fields.find((f) => f.code === stageColumn.key);

            originalStages?.forEach((o) => {
                if (o.id === field.value) {
                    config.original["Stage"] = o.name;
                }
            });

            sourceStages?.forEach((o) => {
                if (o.id === variables?.stageId) {
                    config.source["Stage"] = o.name;
                }
            });
        }
    }

    getUserName(firstName, lastName) {
        firstName = firstName || "";
        lastName = lastName || "";

        return String().concat(firstName, " ", lastName);
    }

    getUserNamebyIamUserId(iamUserId) {
        if (iamUserId && Array.isArray(this.props.users?.content)) {
            const user = this.props.users.content.find((user) => user.iamUserId === iamUserId);
            return user ? this.getUserName(user.firstName, user.lastName) : "";
        }
    }

    getTeamUserNameByIamUserId(iamUserId) {
        if (iamUserId && Array.isArray(this.props.usersWithTeam?.users)) {
            const user = this.props.usersWithTeam.users.find((user) => parseInt(user.iamUserId) === iamUserId);
            return user ? this.getUserName(user.firstName, user.lastName) : "";
        }
    }

    populateInvoiceCreateData(config, fields, variables) {
        config.original["Trigger"] = "Create Invoice";
        config.source["Invoice Code"] = variables?.name || "";
        let commissionUser = "Created By"
        if(variables?.commissionPerson === "SALES_PERSON") {
            commissionUser = "Sales Person"
        }
        config.source[commissionUser] = this.getUserName(variables?.user?.firstName, variables?.user?.lastName) || "-";
    }

    populateExpenseCreateData(config, fields, variables) {
        config.original["Trigger"] = "Create Expense";
        config.source["Expense ID"] = variables?.code || "";
    }

    populateSplitWorkFlowData(config, fields, variables) {
        fields?.forEach((field) => {
            switch (field.field_type) {
                case WORKFLOW_NODE_MAPPING[SPLIT_ACTION_TYPE.DESIGNATION_CHECK]:
                    const designation = [];
                    field?.conditions.forEach((c) => {
                        if (c.code === "designation") {
                            designation.push(c.value);
                        }
                    });
                    config.original["Designation"] = designation.join(", ");
                    config.source["Designation"] = variables?.user?.designation ? variables?.user?.designation : "-";
                    break;
            }
        });
    }

    populateDesignationData(config, fields, variables) {
        const designation = [];
        fields?.forEach((field) => {
            switch (field.app_node_code) {
                case WORKFLOW_NODE_MAPPING[SPLIT_ACTION_TYPE.DESIGNATION]:
                    if (field.code === "designation") {
                        designation.push(field.value);
                        config.original["Designation"] = designation.join(", ");
                        config.source["Designation"] = variables?.user?.designation ? variables?.user?.designation : "-";
                    }
                    break;
            }
        });
    }

    populateCommissionData(config, fields, variables) {
        let commissionType;
        let commissionValue;

        fields?.some((field) => {
            commissionType = field.code;
            commissionValue = field.value;
        });

        if (commissionType === "flatAmount") {
            config.original["Commission Type"] = "Flat";
            config.original["Commission Value"] = commissionValue ? FormatCurrencyService.format(commissionValue) : "-";
        } else if (commissionType === "percentageOfDealCost") {
            config.original["Commission Type"] = "Percentage of Total Amount";
            config.original["Commission Value"] = `${commissionValue}%`;
        }

        config.source["Total Amount"] = variables?.amount ? FormatCurrencyService.format(variables?.amount) : "-";
        config.source["Commission Amount"] = variables?.commissionAmount ? FormatCurrencyService.format(variables?.commissionAmount) : "-";
    }

    populateInvoiceCommissionData(config, fields, variables) {
        let commissionType;
        let commissionValue;

        for (let field of fields) {
            switch (field.code) {
                case "invoiceAmount":
                    const entries = field.value?.split(",");
                    if (Array.isArray(entries) && variables?.amount >= entries[0] && variables?.amount <= entries[1]) {
                        commissionValue = entries[2];
                        commissionType = entries[3];
                    }
                    break;
                default:
                    break;
            }

            if (commissionType) {
                break;
            }
        }

        if (commissionType === "flatAmount") {
            config.original["Commission Type"] = "Flat";
            config.original["Commission Value"] = commissionValue ? FormatCurrencyService.format(commissionValue) : "-";
        } else if (commissionType === "percentageOfDealCost") {
            config.original["Commission Type"] = "Percentage of Total Amount";
            config.original["Commission Value"] = `${commissionValue}%`;
        }

        config.source["Total Amount"] = variables?.amount ? FormatCurrencyService.format(variables?.amount) : "-";
        config.source["Commission Amount"] = variables?.commissionAmount ? FormatCurrencyService.format(variables?.commissionAmount) : "-";
    }

    populateExpenseApprovalData(config, fields, variables) {
        if (Array.isArray(fields)) {
            for (let field of fields) {
                let approvalFor;
                if (field.isAllRequiredUser) {
                    approvalFor = field.approvalRequiredUsers ? field.approvalRequiredUsers.split(",") : [];
                } else {
                    approvalFor = field.approvalFor ? field.approvalFor.split(",") : [];
                }

                const approvalForUsers = [];
                approvalFor.forEach((user) => {
                    approvalForUsers.push(this.getUserNamebyIamUserId(parseInt(user)));
                });

                config.original["Approval For"] = approvalForUsers.join(", ");
                config.source["Applicant Name"] = this.getUserNamebyIamUserId(parseInt(variables.iamUserId));

                if (Array.isArray(field.conditions)) {
                    for (let condition of field.conditions) {
                        switch (condition.code) {
                            case "totalAmount":
                                config.original["Total Amount"] = `${FILTER_OPERATORS_NAMES[condition.opr]} ${condition.value}`;
                                config.source["Expense Amount"] = variables?.amount;
                                break;
                            default:
                                break;
                        }
                    }
                }                
            }
        }
    }

    populateStageChangeData(config, fields, variables) {
        let originalStages;
        let sourceStages;

        fields.find((f) => {
            switch (f.code) {
                case "jobPipelineId":
                    if(!Utility.isEmpty(variables?.jobPipelineName)) {
                        config.original["Job Pipeline"] = variables.jobPipelineName;
                        config.source["Job Pipeline"] = variables.jobPipelineName;
                    } else {
                        this.jobPipelines.forEach((p) => {
                            if (p.id === f.value) {
                                originalStages = p.stages;
                                config.original["Job Pipeline"] = p.name;
                            }
    
                            if (p.id === variables?.jobPipelineId) {
                                sourceStages = p.stages;
                                config.source["Job Pipeline"] = p.name;
                            }
                        });
                    }
                    
                    break;
                case "oldStageId":
                    if (f.value !== "any") {
                        if(!Utility.isEmpty(variables?.oldStageName)) {
                            config.original["From Stage"] = variables.oldStageName;
                            config.source["From Stage"] = variables.oldStageName;
                        } else {
                            originalStages?.forEach((s) => {
                                if (s.id === f.value) {
                                    config.original["From Stage"] = s.name;
                                }
                            });
                        }
                    } else {
                        config.original["From Stage"] = "Any";
                        if(!Utility.isEmpty(variables?.oldStageName)) {
                            config.source["From Stage"] = variables.oldStageName;
                        }
                    }

                    
                    break;
                case "newStageId":
                    if (f.value !== "any") {

                        if(!Utility.isEmpty(variables?.newStageName)) {
                            config.original["To Stage"] = variables.newStageName;
                            config.source["To Stage"] = variables.newStageName;
                        } else {
                            originalStages?.forEach((s) => {
                                if (s.id === f.value) {
                                    config.original["To Stage"] = s.name;
                                }
                            });
                        }
                        
                    } else {
                        config.original["To Stage"] = "Any";
                        if(!Utility.isEmpty(variables?.newStageName)) {
                            config.source["To Stage"] = variables.newStageName;
                        }
                        
                    }
                    break;
            }
        });
    }

    populateSendMailData(config, fields, variables) {
        const original = {};
        const source = {};
        fields?.forEach((field) => {
            switch (field.code) {
                case "sender_name":
                    original["Name"] = field.value;
                    source["Name"] = variables?.emailRequest?.name || variables?.emailRequest?.sender_name;
                    break;
                case "sender_mail":
                    original["From"] = field.value;
                    source["From"] = variables?.emailRequest?.from || variables?.emailRequest?.sender_mail;
                    break;
                case "recipientType":
                    original["To"] = field.value;
                    if (Array.isArray(variables?.emailRequest?.to_email_addresses)) {
                        source["To"] = variables?.emailRequest?.to_email_addresses[0] || "";
                    } else {
                        source["To"] = variables?.emailRequest?.to;
                    }
                    break;
                case "subject":
                    original["Subject"] = field.value;
                    source["Subject"] = variables?.emailRequest?.subject;
                    break;
                case "body":
                    original["Body"] = this.addPlaceholderInEmailBody(field.value);
                    if (variables?.emailRequest?.body) {
                        source["Body"] = variables?.emailRequest?.body ? encodeBase64Uri(decodeURIComponent(variables?.emailRequest?.body)) : "";
                    } else if (variables?.emailRequest?.email_template_html) {
                        source["Body"] = variables?.emailRequest?.email_template_html ? decodeURIComponent(variables?.emailRequest?.email_template_html) : "";
                    }
                    break;
                case "reply_to":
                    original["Reply To"] = field.value;
                    source["Reply To"] = variables?.emailRequest?.replyTo || variables?.emailRequest?.reply_to;
                    break;
            }
        });

        config.original["Email Template"] = `<span class="cursor-pointer" onclick="onEmailView('${encodeBase64Uri(JSON.stringify(original))}')"><u>View Email</u></span>`;
        if (variables) {
            config.source["Email Template"] = `<span class="cursor-pointer" onclick="onEmailView('${encodeBase64Uri(JSON.stringify(source))}')"><u>View Email</u></span>`;
        } else {
            config.source["Email Template"] = "-";
        }
    }

    populateDateAlertData = (config, fields, variables) => {
        let customFields = [];
        if(!Utility.isEmpty(this.props?.customFields?.customFields)) {
            customFields = this.props?.customFields?.customFields
        }
        if (Array.isArray(fields)) {
            for (let field of fields) {
                let datefield = "";
                if(field.code.includes("datefield")) {
                    const datefieldArray = field.code.split("-")
                    if(!Utility.isEmpty(datefieldArray)) {
                        if(datefieldArray[1] === "custom_field") {
                            const cfield = customFields.find(c => c.id === field.value);
                            if(!Utility.isEmpty(cfield)) {
                                config.original["Date Field"] = cfield?.name;  
                            }
                        }
                    } else {
                        const systemFields = AutomationManager.getEmployeeProfileDateField();
                        const sfield = systemFields.find(c=> c.columnCode === field.value)
                        if(!Utility.isEmpty(sfield)) {
                            config.original["Date Field"] = sfield?.name;  
                        }
                    }
                }

                if(field?.code === "triggerOn") {
                    config.original["Trigger On"] = TRIGGER_ON_CONDITION[field.value];
                }

                if (field.code === "daysCriteria" && Array.isArray(field.conditions)) {
                    let filterCriteria = "";
                    for (let condition of field.conditions) {
                        switch(condition.code) {
                            case DATE_ALERT_CRITERIA.BEFORE:
                                filterCriteria = `${condition.value} day(s) ${DATE_ALERT_CRITERIA.BEFORE} selected date field's date`;
                                break;
                            case DATE_ALERT_CRITERIA.AFTER:
                                filterCriteria = `${condition.value} day(s) ${DATE_ALERT_CRITERIA.AFTER} selected date field's date`;
                                break;
                            case DATE_ALERT_CRITERIA.ON:
                                filterCriteria = `${DATE_ALERT_CRITERIA.BEFORE} selected date field's date`;
                                break;
                        }
                    }
                    config.original["Days criteria"] = filterCriteria;
                }

                if (field.code === "employeeConditions" && Array.isArray(field.conditions)) {
                    const employeeFilter = [];
                    const tableColumnsData = TableManger.getTableVisibleColumns(TABLES.EMPLOYEE_LIST)
                    for (let condition of field.conditions) {
                        let columnName = "";
                        const employeeFieldArray = condition.code.split("-")
                        if(!Utility.isEmpty(employeeFieldArray)) {
                            let fieldId = employeeFieldArray[0];
                            if(employeeFieldArray[1] === "custom_field") {
                                const cfield = customFields.find(c => c.id === fieldId);
                                if(!Utility.isEmpty(cfield)) {
                                    columnName = cfield?.name;  
                                }
                            } else {
                                let cfield = tableColumnsData.find(t => t.columnCode === fieldId);
                                if(!Utility.isEmpty(cfield)) {
                                    columnName = cfield.name
                                }
                            }
                        } else {
                            let cfield = tableColumnsData.find(t => t.columnCode === field.code);
                            if(!Utility.isEmpty(cfield)) {
                                columnName = cfield.name
                            }
                        }
                        const value = this.employeeFieldValue(condition)
                        employeeFilter.push(`${columnName} ${FILTER_OPERATORS_NAMES[condition.opr]}  ${value}`);
                    }
                    config.original["Employee filter"] = employeeFilter.join(",");  
                }

                
                              
            }

            // config.source['isDateAlertExecuted'] = variables?.isDateAlertExecuted
            // config.source["Filtered Users"] = !Utility.isEmpty(variables?.totalUsersToUpdate) ? this.getTotalUsersToUpdate(variables?.totalUsersToUpdate) : "No filtered employees";
            config.source["Email Sent users"] = !Utility.isEmpty(variables?.emailSentUser) ? this.getTotalUsersToUpdate(variables?.emailSentUser) : "Email sent to 0 employees";
            config.source["Date Alert execution date"] = variables?.tenantCurrentTime || moment(variables?.sys_date, DATE_FORMAT.SLASH.DDMMYYYY).format(DATE_FORMAT.YYYYMMDD);
        }
    }

    populateLeaveCreateData(config, fields, variables) {
        config.original["Trigger"] = "Time Off Created";
        config.source["Applicant Name"] = variables?.iamUserId ? this.getTeamUserNameByIamUserId(parseInt(variables.iamUserId)) : "";
        config.source["From Date"] = variables?.fromDate ? Utility.formatDate(variables.fromDate, DATE_FORMAT.YYYYMMDD_HHMMSS) : "";
        config.source["To Date"] = variables?.toDate ? Utility.formatDate(variables.toDate, DATE_FORMAT.YYYYMMDD_HHMMSS) : "";
    }

    populateLeaveApprovalData(config, fields, variables) {
        if (Array.isArray(fields)) {
            for (let field of fields) {
                let approvalFor;
                if (field.isAllRequiredUser) {
                    approvalFor = field.approvalRequiredUsers ? field.approvalRequiredUsers.split(",") : [];
                } else {
                    approvalFor = field.approvalFor ? field.approvalFor.split(",") : [];
                }

                const approvalForUsers = [];
                approvalFor.forEach((user) => {
                    approvalForUsers.push(this.getTeamUserNameByIamUserId(parseInt(user)));
                });

                config.original["Approval For"] = approvalForUsers.join(", ");
                config.source["Applicant Name"] = this.getTeamUserNameByIamUserId(parseInt(variables.iamUserId));

                if (Array.isArray(field.conditions)) {
                    for (let condition of field.conditions) {
                        switch (condition.code) {
                            case "any":
                                config.original["Time Off Policy"] = "Any";
                                config.source["Time Off Policy"] = variables?.leaveTypeName || "";
                                break;
                            default:
                                config.original["Time Off Policy"] = condition.type || "";
                                config.source["Time Off Policy"] = variables?.leaveTypeName || "";
                                break;
                        }

                        config.original["Time Off Duration"] = `${FILTER_OPERATORS_NAMES[condition.opr]} ${condition.value}`;
                        config.source["Time Off Duration"] = variables?.duration;
                    }                    
                }                
            }
        }
    }

    getTotalUsersToUpdate = (users) => {
        const usernames = [];
        for (const c in users) {
            usernames.push(`${users[c].firstName} ${users[c].lastname}`)
        }
        return usernames.join(",")
    }

    employeeFieldValue = (c) => {
        switch(c.type) {
            case INPUT_TYPE.DATE:
                return moment(c.value).format(DATE_FORMAT.YYYYMMDD)
        }
        return c.value
    }

    addPlaceholderInEmailBody(encodedBody) {
        let body;
        if (encodedBody) {
            body = decodeBase64Uri(encodedBody);
            const columns = TableManger.getTableColumns(TABLES.CANDIDATE);
            columns?.forEach((c) => {
                const placeholder = `%${c.id}%`;
                if (body.includes(placeholder)) {
                    body = body.replaceAll(placeholder, c.name);
                }
            });

            body = encodeBase64Uri(body);
        }

        return body || encodedBody;
    }

    displayEmailView(data) {
        const email = JSON.parse(decodeBase64Uri(data));

        const emailView = 
        `<div style="height: 100%; overflow: hidden;">
            <div class="mb-m row">
                <div class="fs-l">Email Template View</div>
                <div class="ml-auto">
                    <img class="ic-s cursor-pointer" onclick="onEmailViewClose()" src="${DKIcons.ic_close}" />
                </div>
            </div>
            <div class="p-v-xs">
                <span class="text-gray">From Name: </span>
                <span>${email.Name}</span>
            </div>
            <div class="p-v-xs">
                <span class="text-gray">From Email: </span>
                <span>${email.From}</span>
            </div>
            <div class="p-v-xs">
                <span class="text-gray">Recipient: </span>
                <span>${email.To}</span>
            </div>
            <div class="p-v-xs">
                <span class="text-gray">Subject: </span>
                <span>${email.Subject}</span>
            </div>
            <div class="mt-s custom-scroll" style="height: calc(100% - 130px); overflow: auto; border: 1px solid lightgrey;">
                <div class="p-m">${decodeBase64Uri(email.Body)}</div>
            </div>
        </div>`

        const content = document.createElement("div");
        content.id = "dk-email-view";
        content.className = "email-view visibility-hidden"
        content.innerHTML = emailView;

        const background = document.createElement("div");
        background.id = "dk-email-view-background";
        background.className = "alert-background visibility-hidden";

        document.getElementById("root").appendChild(background);
        document.getElementById("root").appendChild(content);

        setTimeout(() => {
            background.classList.remove("visibility-hidden");
            content.classList.remove("visibility-hidden");
        }, 250);
    }

    registerGlobalFunctions(register) {
        if (register) {
            window.onEmailView = this.displayEmailView;
            window.onEmailViewClose = function() {
                const root = document.getElementById("root");
                const view = document.getElementById("dk-email-view");
                const background = document.getElementById("dk-email-view-background");
                
                if (view) {
                    root.removeChild(view);
                }
    
                if (background) {
                    root.removeChild(background);
                }
            }
        } else {
            if (window.onEmailViewClose) {
                window.onEmailViewClose();
            }

            window.onEmailView = null;
            window.onEmailViewClose = null;
        }
    }

    generateColumnId(index) {
        return `STEP${index}`;
    }

    generateEndAutomationColumnId() {
        return `STEP${this.state.maxSteps + 1}`;
    }

    setReportData(rowData, currentPage, totalPageCount) {
        const columnData = deepClone(WORKFLOW_REPORT_COLUMNS);

        for (let i = 1; i <= this.state.maxSteps; i++) {
            columnData.push({
                id: this.generateColumnId(i),
                key: this.generateColumnId(i),
                columnCode: this.generateColumnId(i),
                index: columnData.length + 1,
                name: `Step ${i}`,
                datasource: [],
                editable: false,
                hidden: false,
                options: null,
                required: true,
                systemField: true,
                type: "text",
                uiVisible: true,
                width: 350
            });
        }

        //End Automation Column - Last Column
        columnData.push({
            id: this.generateEndAutomationColumnId(),
            key: this.generateEndAutomationColumnId(),
            columnCode: this.generateEndAutomationColumnId(),
            index: columnData.length + 1,
            name: `Step ${this.state.maxSteps + 1}`,
            datasource: [],
            editable: false,
            hidden: false,
            options: null,
            required: true,
            systemField: true,
            type: "text",
            uiVisible: true,
            width: 130
        });

        this.setState({
            currentPage: currentPage || 1,
            totalPageCount: totalPageCount || 1,
            reportData: {
                columnData: columnData,
                rowData: rowData,
                originalData: rowData,
                filter: this.state.filters
            }
        });
    }

    getAutomationName(id) {
        const automation = this.state.automations.find((a) => a.wId === id);
        return automation ? automation.name : "";
    }

    onFilter(dataList, queries) {}

    onSearch(searchStr) {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
            this.getAutomationReport(searchStr);
        }, 250);
    }

    getDatePeriodText(startDate, endDate) {
        if (startDate && endDate) {
            return `${Utility.formatDate(moment(startDate).format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)} - ${Utility.formatDate(moment(endDate).format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)}`;
        }

        return `${Utility.formatDate(moment().startOf('month').format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)} - ${Utility.formatDate(moment().endOf('month').format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)}`;
    }

    renderBody() {
        return (
            <div className="column parent-width flex-1">
                <div className="row justify-content-start">
                    <div className="column">
                        <DKLabel text={"Workflow Report of "} className="fw-m fs-l" />
                    </div>
                    <div className="column mr-s" style={{ zIndex: 4, width: "230px" }}>
                        <DKInput
                            type={INPUT_TYPE.DROPDOWN}
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            dropdownConfig={{
                                allowSearch: this.state.automations.length > 7,
                                data: this.state.automations,
                                renderer: (i, item) => item.name,
                                onSelect: (i, value) => {
                                    this.setState({
                                        currentPage: 1
                                    }, () => {
                                        this.setAutomation(value?.wId);
                                    });
                                }
                            }}
                            value={this.getAutomationName(this.state.selectedAutomation)}
                            onChange={() => { }}
                        />
                    </div>
                    <div className="column" style={{ zIndex: 99 }}>
                        <DKButton
                            className="bg-app text-white"
                            title={this.getDatePeriodText(this.state.datePeriod.startDate, this.state.datePeriod.endDate)}
                            icon={calender}
                            onClick={(value) => {
                                this.setState({
                                    datePeriod: {
                                        toggle: !this.state.datePeriod.toggle,
                                        startDate: this.state.datePeriod.startDate,
                                        endDate: this.state.datePeriod.endDate,
                                        defaultDate: true
                                    }
                                });
                            }}
                        />
                        {this.state.datePeriod.toggle && (
                            <DKCalendar
                                className="position-absolute border-m shadow-m bg-white z-index-1 mt-s"
                                isDateRange={true}
                                startDate={this.state.datePeriod.startDate ? new Date(this.state.datePeriod.startDate) : new Date()}
                                endDate={this.state.datePeriod.endDate ? new Date(this.state.datePeriod.endDate) : new Date()}
                                onSelectDate={(startDate, endDate) => {
                                    if (startDate && endDate) {
                                        this.setState({
                                            datePeriod: {
                                                toggle: false,
                                                startDate: startDate,
                                                endDate: endDate,
                                                defaultDate: false
                                            }
                                        }, () => {
                                            this.getAutomationReport();
                                        });
                                    }
                                }}
                                onClose={() => {
                                    this.setState({
                                        datePeriod: {
                                            toggle: false,
                                            startDate: this.state.datePeriod.startDate,
                                            endDate: this.state.datePeriod.endDate,
                                            defaultDate: false
                                        }
                                    });
                                }}
                            />
                        )}
                    </div>
                </div>
                <div className="column" style={{ marginTop: "-43px", height: "70%" }}>
                    <div className="flex-1 position-relative" style={{ minHeight: "200px" }}>
                        <Suspense
                            fallback={
                                <div className="row justify-content-center">
                                    <DKSpinner />
                                </div>
                            }
                        >
                            <DataGridHolderPayroll
                                tableName={TABLES.AUTOMATION}
                                allowColumnEdit={false}
                                allowColumnDelete={false}
                                allowColumnShift={false}
                                allowSearch={true}
                                allowFilter={false}
                                allowColumnAdd={false}
                                allowDataExport={false}
                                gridData={this.state.reportData}
                                currentPage={this.state.currentPage}
                                totalPageCount={this.state.totalPageCount}
                                allowRowEdit={false}
                                filter={this.state.filters}
                                onPaginationClick={(requestedPageNumber) => {
                                    this.setState({
                                        currentPage: requestedPageNumber
                                    }, () => {
                                        this.getAutomationReport();
                                    });
                                }}
                                onFilter={(dataList, queries) => {
                                    this.onFilter(dataList, queries);
                                }}
                                onSearch={(searchStr) => {
                                    this.onSearch(searchStr);
                                }}
                            />
                        </Suspense>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return this.renderBody();
    }
}

const mapStateToProps = (state) => ({
    users: state?.payroll?.formData?.userWithExpenseGroup || {},
    customFields: state?.customField?.data || {},
    usersWithTeam: state?.payroll?.formData.userWithTeams || {}
})

const mapDispatchToProps = { fetchUsersExpenseGroup, fetchUsersListWithTeams, fetchCustomFields};

export default connect(mapStateToProps, mapDispatchToProps)(WorkflowReport);
